import { Pipe, PipeTransform, Inject } from "@angular/core";

@Pipe({
    name: "formatHtmlToPlaintext",
    pure: true
})
export class FormatHtmlToPlaintextPipe implements PipeTransform {

    constructor () { }

    transform (value: string): string {
        return value ? String(value).replace(/<[^>]+>/gm, "") : "";
    }
}